import { useEffect, useState, useMemo, useCallback } from 'react';
import { Box, Link, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import { InfoFeedClient } from '../../helpers/client';
import { InfoFeedOverview } from 'orderme-api-integration-client';
import { apiKey, imagesUri } from '../../helpers/clientConfigs';
import { ImageLoader } from '../imgLoader/imgLoader';
import { BreadcrumbsBar } from '../breadcrumbs/breadcrumbsBar';
import { useTranslation } from 'react-i18next';
import { NewsRoute } from '../../routes/allRoutes';
import { useRouteNavigator } from '../../routes/useRouteNavigator';

export function NewsList() {
  const [news, setNews] = useState<InfoFeedOverview[]>([]);
  const infoFeedClient = useMemo(() => new InfoFeedClient(), []);
  const { t } = useTranslation();
  const routeNavigator = useRouteNavigator();

  const fetchNews = useCallback(async () => {
    try {
      const response = await infoFeedClient.getAll();
      setNews(response);
    } catch (error) {
      console.error('Error fetching news:', error);
    }
  }, [infoFeedClient]);

  useEffect(() => {
    fetchNews();
  }, [fetchNews]);

  const openNews = (newsItem: InfoFeedOverview) => {
    routeNavigator.goToNewsItem(newsItem.id, newsItem.title);
  };

  return (
    <Box sx={{ mt: '10px' }}>
      <BreadcrumbsBar paths={[{ path: NewsRoute }]} />
      <Grid
        sx={{
          p: { xs: '10px', md: '20px' },
          backgroundColor: 'white',
          color: 'black',
          width: '100%',
          borderRadius: '15px',
        }}
      >
        <Grid container spacing={2}>
          {news.map((item, index) => (
            <Grid size={{ xs: 12, sm: 6, md: 4 }} key={index}>
              <Box
                sx={{
                  '&:hover': { cursor: 'pointer' },
                }}
                onClick={() => openNews(item)}
              >
                <ImageLoader
                  sx={{
                    width: '100%',
                    height: 'auto',
                    borderRadius: '15px',
                    objectFit: 'cover',
                    display: 'block',
                  }}
                  src={`${imagesUri}/${item.imageId}?orderme-api-key=${apiKey}&height=500`}
                  alt={item.title}
                />
              </Box>
              <Box>
                <Typography variant="h6" fontWeight="bold">
                  {item.title}
                </Typography>
                <Typography>{item.heading}</Typography>
              </Box>
              <Box sx={{ textAlign: 'right', marginBottom: 'auto' }}>
                <Link
                  component="button"
                  underline="hover"
                  color="secondary.main"
                  fontWeight="bold"
                  sx={{ verticalAlign: 'baseline', fontSize: '1.2rem' }}
                  onClick={() => openNews(item)}
                >
                  {t('news:readMore')}
                  {'>'}
                </Link>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Box>
  );
}
